import i18n from "i18next";

/**
 * Map mã lỗi nghiệp vụ (BE trả ở `response.data.error_code`) → KEY i18n của FE.
 * Message do FE sở hữu (song ngữ qua i18n FE), không phụ thuộc text BE.
 */
const ERROR_CODE_I18N_KEY: Record<string, string> = {
  out_of_scope: "gprocess:mission-management.changeHandler.errorCodes.out_of_scope",
  not_current_handler:
    "gprocess:mission-management.changeHandler.errorCodes.not_current_handler",
  change_to_self:
    "gprocess:mission-management.changeHandler.errorCodes.change_to_self",
  task_not_active:
    "gprocess:mission-management.changeHandler.errorCodes.task_not_active",
  task_not_found:
    "gprocess:mission-management.changeHandler.errorCodes.task_not_found",
  change_request_not_found:
    "gprocess:mission-management.changeHandler.errorCodes.change_request_not_found",
  change_request_not_pending:
    "gprocess:mission-management.changeHandler.errorCodes.change_request_not_pending",
  pending_change_request:
    "gprocess:mission-management.changeHandler.errorCodes.pending_change_request",
  manager_out_of_scope:
    "gprocess:mission-management.changeHandler.errorCodes.manager_out_of_scope"
};

export const renderServerErrorMsg = (error: any, toast: any): void => {
  if (error && error.response && error.response.status === 422) {
    const messages = error.response.data?.message;
    let messageText = i18n.t("layout:common.somethingWrong");
    if (typeof messages === "string") {
      messageText = messages;
    } else if (Array.isArray(messages) && messages.length > 0) {
      messageText = messages.join(" ");
    }
    toast.error(messageText);
    return;
  } else if (error && error.response && error.response.status === 403) {
    let messageText = i18n.t("layout:common.youAreNotPermisionToDoThis");
    toast.error(messageText);
    return;
  } else {
    toast.error(i18n.t("layout:common.somethingWrong"));
  }
};

/**
 * Lớp mỏng cho các thao tác g-process (đổi người xử lý / phê duyệt / đổi người quản lý quy
 * trình). Nếu BE trả MÃ LỖI nghiệp vụ (`response.data.error_code`) đã được FE định nghĩa thì
 * hiện message i18n của FE; các case khác (mã lạ / không có mã) → DÙNG CHUNG
 * `renderServerErrorMsg` (lỗi chung). Tách riêng — thay vì nhét bản đồ mã vào helper chung
 * (92 file dùng) — để mã generic ("not_found", "out_of_scope"...) của service khác KHÔNG vô
 * tình khớp và hiện nhầm message g-process.
 */
export const renderErrorByCode = (error: any, toast: any): void => {
  const code = error?.response?.data?.error_code;
  const key = typeof code === "string" ? ERROR_CODE_I18N_KEY[code] : undefined;
  if (key) {
    toast.error(i18n.t(key));
    return;
  }
  renderServerErrorMsg(error, toast);
};
